import React, { useEffect, useState } from "react";
import RealLamb from "../../assets/RealEnglishImages/REALLogo.png"; // Your main logo
import "./LoaderMainPage.css"; // Import CSS for animation

const LoaderMainPage = ({ onFinish }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Wait 2.5s before fading out, then remove LoaderMainPage
    setTimeout(() => setFadeOut(true), 2500);
    setTimeout(() => onFinish(), 3500);
  }, [onFinish]);

  return (
    <div className={`loader-container ${fadeOut ? "fade-out" : ""}`}>
      <img src={RealLamb} alt="Loading..." className="loader-logo" />
    </div>
  );
};

export default LoaderMainPage;
